import { PriceSimulationRenderingExtended } from '@sitecore/types/manual/be/PriceSimulationExtended';
import * as yup from 'yup';
import '../../../utils/customYupValidation';

/**
 * Schema for the email proposal form on the price simulation result step
 */
export const emailProposalFormSchema = (fields: PriceSimulationRenderingExtended['fields']) =>
  yup.object({
    emailConsent: yup.boolean().oneOf([true], fields.proposalStep.emailConsentFormField.value.validationMessage),
    email: yup
      .string()
      .validEmail(fields.proposalStep.emailFormField.value.validationMessage)
      .required(fields.proposalStep.emailFormField.value.requiredMessage),
  });

export type EmailProposalFormSchema = {
  emailConsent: boolean;
  email: string;
};
